"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_smooth_collapse_1 = __importDefault(require("react-smooth-collapse"));
const CopyButton_1 = __importDefault(require("../CopyButton"));
const Button_1 = __importDefault(require("../Button"));
const CodeBlock_1 = __importDefault(require("../CodeBlock"));
class CodeExample extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: this.props.initialOpen,
        };
    }
    render() {
        const { code } = this.props;
        return (react_1.default.createElement("div", { className: 'row' },
            react_1.default.createElement("div", { className: 'col-md-12', style: { paddingTop: '10px' } },
                react_1.default.createElement(react_smooth_collapse_1.default, { expanded: this.state.open },
                    react_1.default.createElement(CodeBlock_1.default, { code: code })),
                react_1.default.createElement("div", { className: 'clearfix' },
                    react_1.default.createElement(Button_1.default, { variant: 'link', onClick: () => this.setState(prevState => ({ open: !prevState.open })), className: 'pull-right' }, this.state.open ? 'Hide code' : 'Show code'),
                    this.state.open
                        ? (react_1.default.createElement(CopyButton_1.default, { style: { marginRight: '9px' }, variant: 'link', className: 'pull-right' }))
                        : null))));
    }
}
exports.default = CodeExample;
CodeExample.propTypes = {
    code: prop_types_1.default.string,
    initialOpen: prop_types_1.default.bool,
};
CodeExample.defaultProps = {
    initialOpen: true,
};
